"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataProvider = void 0;
exports.useData = useData;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : dataContext.js
* Description : Ce fichier contient des données disponibles partout dans l'application  
*               pour son bon fonctionnement.
* Date de création : 19 novembre 2024
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ // None
/* Hook */
var DataContext = /*#__PURE__*/(0, _react.createContext)(null);
function useData() {
  return (0, _react.useContext)(DataContext);
}
var DataProvider = exports.DataProvider = function DataProvider(_ref) {
  var children = _ref.children;
  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    months = _useState2[0],
    setMonths = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    validationStatus = _useState4[0],
    setValidationStatus = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    targetTypes = _useState6[0],
    setTargetTypes = _useState6[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DataContext.Provider, {
    value: {
      months: months,
      setMonths: setMonths,
      validationStatus: validationStatus,
      setValidationStatus: setValidationStatus,
      targetTypes: targetTypes,
      setTargetTypes: setTargetTypes
    },
    children: children
  });
};